import "./styles.scss";

import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import classnames from "classnames";

import task_status_data from "libs/task_status_data.json";
import task_priority_data from "libs/task_priority_data.json";
import countries from "libs/countries.json";
import useResponsive from "libs/helpers/useResponsive";

import avatarImage from "assets/images/avatar-placeholder.png";
import { ReactComponent as FlagIcon } from "assets/icons/new/flag.svg";
import { ReactComponent as ArrowIcon } from "assets/icons/new/forward-arrow.svg";
import Button from "components/Button";

const mainClass = "webmasters-admin-content-card";

const Card = ({
  id,
  name,
  photo,
  email,
  phone,
  priority_count,
  status_count,
}) => {
  const { t } = useTranslation();
  const { max } = useResponsive();

  const phone_formatted = !!phone?.number
    ? `${
        countries?.find((item) => item?.code === phone?.code)?.dialling_code ||
        ""
      } ${phone?.number}`
    : undefined;

  return (
    <div className={mainClass}>
      <div className={`${mainClass}__header`}>
        <p>{name}</p>
        {id && (
          <Link to={`/webmasters/${id}/account-settings`}>
            <span>{t("Edit")}</span>
            <i>
              <ArrowIcon />
            </i>
          </Link>
        )}
      </div>
      <div className={`${mainClass}__details`}>
        <div className={`${mainClass}__details-avatar`}>
          <div>
            <img src={photo || avatarImage} alt="" />
          </div>
        </div>
        <div className={`${mainClass}__details-contact`}>
          <div>
            <span>{t("Email address")}:</span>
            <span>{email ? <a href={`mailto:${email}`}>{email}</a> : "-"}</span>
          </div>
          <div>
            <span>{t("Phone number")}:</span>
            <span>
              {phone_formatted ? (
                <a href={`tel:${phone_formatted}`}>{phone_formatted}</a>
              ) : (
                "-"
              )}
            </span>
          </div>
        </div>
      </div>
      {max.sm ? (
        <div className={`${mainClass}__tasks`}>
          <Button
            variant="transparent"
            href={`/webmasters/${id}`}
            external_href={false}
          >
            {t("Tasks")}
          </Button>
        </div>
      ) : (
        <>
          <div className={`${mainClass}__tasks`}>
            <p className={`${mainClass}__tasks-label`}>
              {t("Number of tasks by priority")}
            </p>
            <div
              className={`${mainClass}__tasks-pills ${mainClass}__tasks-pills--priority`}
            >
              {task_priority_data.map(({ key, label, color }) => (
                <Link
                  key={key}
                  className={classnames({ [color]: !!color })}
                  to={`/webmasters/${id}?priority=${key}`}
                >
                  <i className="flag">
                    <FlagIcon />
                  </i>
                  {t(label)}
                  <span>{priority_count?.[key] || "-"}</span>
                </Link>
              ))}
            </div>
          </div>
          <div className={`${mainClass}__tasks`}>
            <p className={`${mainClass}__tasks-label`}>
              {t("Number of tasks by status")}
            </p>
            <div
              className={`${mainClass}__tasks-pills ${mainClass}__tasks-pills--status`}
            >
              {task_status_data
                .filter(
                  ({ key }) =>
                    !["client_verification", "closed", "canceled"].includes(
                      key,
                    ),
                )
                .map(({ key, label, color }) => (
                  <Link
                    key={key}
                    className={classnames({ [color]: !!color })}
                    to={`/webmasters/${id}?status=${key}`}
                  >
                    <i />
                    {t(label)}
                    <span>{status_count?.[key] || "-"}</span>
                  </Link>
                ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Card;
